// extracted by mini-css-extract-plugin
export default {"image":"AddCartCountModal_image__pzFeK","modalContent":"AddCartCountModal_modalContent__yHPXM"};